import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderStates extends Layout {
	sourceStates: DataSource;
	tableOrderStates: Table;
}
